export default "__VITE_ASSET__VVu2ZvyJ__"